<template>
    <div class="xcard pt-1">
        <h3 class="text-primary text-center mt-0 mb-0">Calificaciones De Estudiantes</h3>

        <v-row dense>
            <v-col cols="2">
                <v-combobox v-model="filtros.gestion" :items="gestiones" label="Gestion" :loading="loadinggestion" :disabled="loadinggestion" hide-details outlined dense></v-combobox>
            </v-col>
            <v-col cols="7">
                <v-combobox v-model="filtros.programa" :items="programas" label="Programa" :loading="loadingprograms" :disabled="loadingprograms" hide-details outlined dense></v-combobox>
            </v-col>
            <v-col cols="3">
                <v-text-field label="Buscar" :disabled="calificaciones.length == 0" placeholder="Buscar en la tabla..." hide-details v-model="buscar" outlined dense></v-text-field>
            </v-col>
        </v-row>

        <div class="table-responsive" style="height: 75vh;">
            <table class="table table-hover table-condensed table-striped" id="midatatablecal">
                <thead style="background:#196391;position: sticky; top: 0; z-index: 1;">
                    <tr class="white--text">
                        <th>Estudiante</th>
                        <th class="px-4">Modulo 1</th>
                        <th class="px-4">Modulo 2</th>
                        <th class="px-4">Modulo 3</th>
                        <th class="px-4">Modulo 4</th>
                        <th class="px-4">Modulo 5</th>
                        <th class="px-4">Modulo 6</th>
                        <th class="px-4">Modulo 7</th>
                        <th class="px-4">Modulo 8</th>
                        <th class="px-4">Modulo 9</th>
                        <th class="px-4">Modulo 10</th>
                        <th class="px-4">Modulo 11</th>
                        <th class="px-4">Modulo 12</th>
                        <th class="px-4">Modulo 13</th>
                        <th class="px-4">Modulo 14</th>
                        <th class="px-4">Modulo 15</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, ind) in calificaciones" :key="ind" class="text-center">
                        <td class="pr-14">{{ c.estudiante }}</td>
                        <td>{{ c.mod1 }}</td>
                        <td>{{ c.mod2 }}</td>
                        <td>{{ c.mod3 }}</td>
                        <td>{{ c.mod4 }}</td>
                        <td>{{ c.mod5 }}</td>
                        <td>{{ c.mod6 }}</td>
                        <td>{{ c.mod7 }}</td>
                        <td>{{ c.mod8 }}</td>
                        <td>{{ c.mod9 }}</td>
                        <td>{{ c.mod10 }}</td>
                        <td>{{ c.mod11 }}</td>
                        <td>{{ c.mod12 }}</td>
                        <td>{{ c.mod13 }}</td>
                        <td>{{ c.mod14 }}</td>
                        <td>{{ c.mod15 }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div><ACalificacionesFiltro ref="acalificacionesfiltro" v-on:listarcalificaciones="onlistar" /></div>
    </div>
</template>

<style scoped>
table tbody th {
    position: relative;
}
table thead th:first-child {
    background: #196391;
    position: sticky;
    left: 0;
    z-index: 1;
}
table tbody td:first-child {
    position: sticky;
    left: 0;
    background: white;
    z-index: 0;
}
</style>

<script>
import ACalificacionesFiltro from "@/components/ACalificacionesFiltro.vue";
import gql from "graphql-tag";
export default {
    data() {
        return {
            gestiones: [2018, 2019, 2020, 2021],
            programas: [],
            modulos: [],
            loadinggestion: false,
            loadingprograms: false,
            loadingmodulos: false,
            filtros: {
                gestion: null,
                programa: null,
                modulo: null,
            },
            calificaciones: [],
            loading: false,
            buscar: "",
            msg: "",
        };
    },
    components: { ACalificacionesFiltro },
    watch: {
        buscar: function() {
            this.myFunction1(this.buscar.trim());
        },
        "filtros.gestion": function() {
            if (this.filtros.gestion) this.listarprogramasgraphql();
        },
        "filtros.programa": function() {
            if (this.filtros.programa) this.listarcalificaciones();
        },
    },
    methods: {
        openfiltro() {
            this.$refs.acalificacionesfiltro.open();
        },
        async listarprogramasgraphql() {
            this.loadingprograms = true;
            this.loadingmodulos = true;
            this.programas = [];
            this.filtros.programa = null;
            const vue = this;
            var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:1, gestion:${this.filtros.gestion}){ id,plataforma_id, course_category_id,fase,version,grupo,estado,codigo,nombre_compuesto} }`;
            await this.$apollo
                .query({ query: sql, variables: { cursor: this.cursor } })
                .then(({ data }) => {
                    let datos = data.getProgramas;
                    datos.forEach((x, indice) => {
                        x.text = `${indice + 1}.- ${x.nombre_compuesto}`;
                        x.value = x.id;
                        vue.programas.push(x);
                    });
                    //window.console.log(datos);
                    vue.loadingprograms = false;
                    vue.loadingmodulos = false;
                })
                .catch(() => {
                    vue.loadingprograms = false;
                    vue.loadingmodulos = false;
                });
        },
        myFunction1(filtro) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd, td, i, j, txtValue;
            table = document.getElementById("midatatablecal");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for (j = 0; j < tdd.length; j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    }
                }
            }
        },
        listarcalificaciones() {
            for (let i = 0; i < 25; i++) {
                let cal = {
                    estudiante: " Fulanito de tal " + i,
                    mod1: Math.floor(Math.random() * (100 + 1)),
                    mod2: Math.floor(Math.random() * (100 + 1)),
                    mod3: Math.floor(Math.random() * (100 + 1)),
                    mod4: Math.floor(Math.random() * (100 + 1)),
                    mod5: Math.floor(Math.random() * (100 + 1)),
                    mod6: Math.floor(Math.random() * (100 + 1)),
                    mod7: Math.floor(Math.random() * (100 + 1)),
                    mod8: Math.floor(Math.random() * (100 + 1)),
                    mod9: Math.floor(Math.random() * (100 + 1)),
                    mod10: Math.floor(Math.random() * (100 + 1)),
                    mod11: Math.floor(Math.random() * (100 + 1)),
                    mod12: Math.floor(Math.random() * (100 + 1)),
                    mod13: Math.floor(Math.random() * (100 + 1)),
                    mod14: Math.floor(Math.random() * (100 + 1)),
                    mod15: Math.floor(Math.random() * (100 + 1)),
                };
                this.calificaciones.push(cal);
            }
        },
        onlistar(filtros) {
            window.console.log(filtros);
        },
    },
    mounted() {},
};
</script>
